const getHighestZIndex = (): number => {
  const bodyChildZIndexes = Array.from(document.querySelectorAll("body *")).map(
    (e) => {
      const element = e as HTMLElement;
      return Number(window.getComputedStyle(element).zIndex) || 1;
    }
  );

  return Math.max(...bodyChildZIndexes);
};

const decodeHtmlEntities = (text: string): string => {
  if (!text) return "";

  const txt = document.createElement("textarea");
  txt.innerHTML = text;
  return txt.value || "";
};

export { getHighestZIndex, decodeHtmlEntities };
